// This function is used to prefill the user name and email in zoho salesiq chatbox
export const zohoPrefillUserDetails = ({ name, email }) => {
    if (name && window?.$zoho) {
        window.$zoho.salesiq.visitor.name(name);
    }
    if (email && window?.$zoho) {
        window.$zoho.salesiq.visitor.email(email);
    }
};
